// Platform detection helpers. The app runs in two contexts:
//
//   • Native (Capacitor on Android/iOS) — all three personas
//     (Player / Scout / Academy) are available with full feature set.
//   • Web (browser PWA) — Academy persona ONLY. Player / Scout routes
//     are guarded and redirect to /auth; AuthScreen hides the persona
//     selector and forces Academy.
//
// The split is enforced by:
//   • PlatformGuard component wrapping the player and scout route
//     blocks in App.tsx (redirects on web).
//   • A single `isWebPlatform()` check at the top of AuthScreen to
//     bypass the persona toggle UI.
//   • The Academy signup defer block in AuthScreen is gated to native
//     only — web users can complete the academy signup flow without
//     hitting the "Coming Soon" toast.

import { Capacitor } from "@capacitor/core";

/** True when running inside the Capacitor WebView on a real device. */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/** True when running in a plain browser (PWA / dev / Play Store
 *  listing preview). The negation of isNativePlatform — kept as a
 *  named function for grep-ability and call-site clarity. */
export function isWebPlatform(): boolean {
  return !Capacitor.isNativePlatform();
}
